import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-79b140d4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "footer-component-root"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-component-root-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/footer-content-2.png",
  alt: "封底图片"
})], -1));

const _hoisted_3 = [_hoisted_2];
export default {
  __name: 'Footer',
  props: {},

  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
    };
  }

};